import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React from 'react'
import { Button, Modal } from 'react-bootstrap'

interface ModalConfirmarAnularLoteProps {
    show: boolean
    setShow: (show: boolean) => void
    anularLote: () => Promise<void>
}

const ModalConfirmarAnularLote = ({
    show,
    setShow,
    anularLote
}: ModalConfirmarAnularLoteProps) => {
    return (
        <Modal show={show} centered style={{ backgroundColor: 'rgba(1,1,1,0.5)' }}>
            <Modal.Header closeButton={false} className="modal-header-danger" >
                <Modal.Title style={{ color: 'white', fontWeight: 'bold' }}>Confirmar Anular Lote</Modal.Title>
            </Modal.Header>

            <Modal.Body style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                <FontAwesomeIcon icon={faExclamationTriangle} color='red' size='3x' />
                <p style={{ fontSize: 15, fontWeight: 'bold', textAlign: 'center', marginTop: 10 }}>¿Está seguro de que desea anular el Lote actual?</p>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="danger" onClick={() => {
                    anularLote()
                }}>
                    Aceptar
                </Button>
                <Button variant="secondary" onClick={() => setShow(false)}>
                    Cerrar
                </Button>
            </Modal.Footer>
        </Modal>
    )
}

export default ModalConfirmarAnularLote
